import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraCombobox, SpecraInput } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { NaicsCodeCombobox } from '../../../components/SharedRecord/NaicsCodeCombobox';
import { formatGovernmentOrgLabel, useGovernmentOrgCatalog } from '../../Delivery/Programs/referenceDataHooks';
import { useLinkCapabilities } from '../../Registries/capabilities/hooks';
import { LandscapeCriterionKind } from '../landscapeForm';
/**
 * The value of one Landscape criterion. The rules engine matches criteria as text
 * (case-insensitive), so pickers store the visible name or code — agency name, capability
 * name, NAICS code — never a registry id. PSC has no list and stays typed.
 */ export function CriterionValueField({ kind, value, onChange }) {
    if (kind === LandscapeCriterionKind.NAICS) {
        return /*#__PURE__*/ _jsx(NaicsCodeCombobox, {
            label: "Criterion value",
            value: value,
            onChange: onChange,
            testId: Testids.landscapes.criterionValue
        });
    }
    if (kind === LandscapeCriterionKind.AGENCY) return /*#__PURE__*/ _jsx(AgencyValue, {
        value: value,
        onChange: onChange
    });
    if (kind === LandscapeCriterionKind.CAPABILITY) return /*#__PURE__*/ _jsx(CapabilityValue, {
        value: value,
        onChange: onChange
    });
    return /*#__PURE__*/ _jsx(SpecraInput, {
        value: value,
        onChange: (e)=>onChange(e.target.value),
        "aria-label": "Criterion value",
        placeholder: "PSC code",
        "data-testid": Testids.landscapes.criterionValue
    });
}
function withCurrent(opts, value) {
    return !value || opts.some((o)=>o.value === value) ? opts : [
        {
            value,
            label: value
        },
        ...opts
    ];
}
function AgencyValue({ value, onChange }) {
    const catalog = useGovernmentOrgCatalog();
    const names = [
        ...new Set((catalog.data ?? []).map((o)=>o.name).filter(Boolean))
    ].sort();
    const labelByName = new Map((catalog.data ?? []).map((o)=>[
            o.name,
            formatGovernmentOrgLabel(o)
        ]));
    return /*#__PURE__*/ _jsx(SpecraCombobox, {
        label: "Criterion value",
        placeholder: "Pick an agency",
        searchPlaceholder: "Search agencies and offices",
        loading: catalog.isLoading,
        options: withCurrent(names.map((n)=>({
                value: n,
                label: labelByName.get(n) ?? n
            })), value),
        value: value || undefined,
        onValueChange: (v)=>onChange(v ?? ''),
        triggerProps: {
            'data-testid': Testids.landscapes.criterionValue
        }
    });
}
function CapabilityValue({ value, onChange }) {
    const caps = useLinkCapabilities(true);
    const names = (caps.data?.capabilities ?? []).map((c)=>c.name).filter(Boolean);
    return /*#__PURE__*/ _jsx(SpecraCombobox, {
        label: "Criterion value",
        placeholder: "Pick a capability",
        searchPlaceholder: "Search capabilities",
        loading: caps.isLoading,
        options: withCurrent(names.map((n)=>({
                value: n,
                label: n
            })), value),
        value: value || undefined,
        onValueChange: (v)=>onChange(v ?? ''),
        triggerProps: {
            'data-testid': Testids.landscapes.criterionValue
        }
    });
}
